import React from 'react'
import PropTypes from 'prop-types'
import isNil from 'lodash/isNil'
import { Indicator, Measure, LocalizedText, ClockIcon } from 'labguard-cdk'
import ThresholdDurationInput from './ThresholdDurationInput'

const TempoIndicator = ({ value, color, onChange, ...props }) => (
  <Indicator
    {...props}
    icon={ClockIcon}
    separator
    title={
      <Measure color={color}>
        <ThresholdDurationInput value={isNil(value) ? '' : value} onChange={onChange} />
      </Measure>
    }
    subtitle={<LocalizedText id="WEB_TIME_DELAY" />}
    color={color}
    height="1.875rem"
  />
)

TempoIndicator.propTypes = {
  value: PropTypes.number,
  color: PropTypes.string,
  onChange: PropTypes.func,
}

export default TempoIndicator
